"use client";

import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/css/modal-video.min.css';

import defaultYouTubeBg from '../../assets/images/backgrounds/ramana-back-for-videos.jpeg';

// VideoOne component
export default function VideoOne({ videoId, videoShape1 }) {
  const [isOpen, setIsOpen] = useState(false);

  // const defaultYouTubeBg = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  const bgImage = videoShape1 ? videoShape1 : defaultYouTubeBg;
  return (
    <>
      {/* Video One Start */}
      <section className="video-one">
        <div className="container">
          <div className="video-one__inner">
            <div
              className="video-one__bg"
              style={{ backgroundImage: `url(${bgImage})` }}
            ></div>
            <div className="video-one__video-link">
              <button
                onClick={() => setIsOpen(true)}
                className="video-popup"
              >
                <div className="video-one__video-icon">
                  <span className="fas fa-play"></span>
                  <i className="ripple"></i>
                </div>
              </button>
              <ModalVideo
                channel="youtube"
                isOpen={isOpen}
                // videoId="BCGsMf27oP0"
                videoId={videoId}
                onClose={() => setIsOpen(false)}
              />
            </div>
          </div>
        </div>
      </section>
      {/* Video One End */}
    </>
  );
}




